import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';

import { SessionStore } from 'app/core/services/session.store';
import { User } from 'app/shared/models/User';

@Component({
    selector: 'app-iadvize',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class IAdvizeComponent {
    private readonly iAdvizeId = 18216;

    private readonly iadvizeUrl = `https://lc.iadvize.com/iadvize.js?sid=${this.iAdvizeId}`;

    private readonly session = inject(SessionStore);

    constructor() {
        effect(() => {
            const userLogin = this.session.user();
            if (userLogin) {
                this.checkForIAdvizeChat(userLogin);
            }
        });
    }

    checkForIAdvizeChat(userLogin: User) {
        const existingScript = document.querySelector(`script[src="${this.iadvizeUrl}"]`);

        if (userLogin.country === 'FR' && !existingScript) {
            this.showIAdvizeChat();
        }
    }

    showIAdvizeChat(): void {
        window.idzCustomData = { connected: true };

        const idz = document.createElement('script');
        idz.type = 'text/javascript';
        idz.async = true;
        idz.src = this.iadvizeUrl;
        document.body.append(idz);
    }
}
